import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, money } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Package } from "lucide-react";

export default function Orders() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user === false) { navigate("/login?redirect=/orders"); return; }
    if (user) {
      api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
    }
  }, [user, navigate]);

  return (
    <div className="pt-28 pb-24 max-w-[900px] mx-auto px-4 md:px-8 min-h-[70vh]" data-testid="orders-page">
      <h1 className="font-display text-4xl md:text-5xl uppercase mb-2">My Orders</h1>
      {user && <p className="text-sm text-gray-500 mb-10">Welcome back, {user.name}</p>}

      {loading ? (
        <p className="uppercase tracking-widest text-gray-400">Loading...</p>
      ) : orders.length === 0 ? (
        <div className="text-center py-20 flex flex-col items-center gap-4" data-testid="orders-empty">
          <Package size={48} className="text-gray-300" />
          <p className="uppercase tracking-widest text-gray-400">No orders yet</p>
          <Link to="/shop/all" className="bg-ink text-cream px-8 py-4 text-xs font-bold uppercase tracking-widest hover:bg-ink/85 transition-colors">Start Shopping</Link>
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {orders.map((o) => (
            <div key={o.id} className="border border-gray-200 p-6" data-testid={`order-${o.order_number}`}>
              <div className="flex justify-between items-start flex-wrap gap-2 border-b border-gray-100 pb-4 mb-4">
                <div>
                  <p className="font-bold uppercase tracking-wide">{o.order_number}</p>
                  <p className="text-xs text-gray-500">{new Date(o.created_at).toLocaleDateString()}</p>
                </div>
                <div className="text-right">
                  <span className="text-xs font-bold uppercase tracking-widest bg-ink text-cream px-3 py-1">{o.status}</span>
                  <p className="font-bold mt-2">{money(o.total)}</p>
                </div>
              </div>
              <div className="flex flex-col gap-3">
                {o.items.map((it, idx) => (
                  <div key={idx} className="flex gap-3 items-center">
                    <img src={it.image} alt={it.name} className="w-12 h-14 object-cover" />
                    <div className="flex-1">
                      <p className="text-sm font-bold uppercase">{it.name}</p>
                      <p className="text-xs text-gray-500">Size {it.size} · Qty {it.quantity}</p>
                    </div>
                    <span className="text-sm font-bold">{money(it.price * it.quantity)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
